/*
 * pf-descripcion.js — PhotoFury, 17/08/2026
 *
 * Pliega la descripcion del producto cuando es muy larga y ofrece un boton para abrirla.
 *
 * Por que: medido en la Nikon Z8, la descripcion son 505 palabras. En movil eso son
 * 3.110 px, y empujaba las resenas, el FAQ y los productos relacionados hasta la
 * pantalla 12. Plegada ocupa ~380 px y el cliente decide si quiere leerla.
 *
 * 🔴 El plegado lo pone ESTE script, no el CSS. Si el JS falla, la descripcion se ve
 * entera: mas vale una ficha larga que una ficha con las especificaciones cortadas y sin
 * forma de abrirlas.
 *
 * Accesible: el boton lleva aria-expanded y aria-controls, y al plegar de nuevo se
 * devuelve el foco al boton. Respeta prefers-reduced-motion.
 */
(function () {
  'use strict';

  var contador = 0;

  var TEXTOS = {
    abrir: { es: 'Leer la descripción completa', en: 'Read the full description' },
    cerrar: { es: 'Mostrar menos', en: 'Show less' }
  };

  function idioma() {
    var l = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    return l === 'en' ? 'en' : 'es';
  }

  function preparar(caja) {
    if (caja.dataset.pfListo === 'si') return;

    var limite = parseInt(caja.dataset.pfAlto, 10) || 380;
    // 🔴 En la ficha el contenido es `.pf-descripcion__cuerpo`; en la cabecera de coleccion
    // es `.collection-hero__description`, que es de Dawn y no conviene renombrar. Se busca la
    // clase propia y, si no esta, se usa el primer hijo. Sin esto el plegado no se aplicaba
    // en las colecciones y la descripcion empujaba el primer producto hasta los 906 px.
    var cuerpo = caja.querySelector('.pf-descripcion__cuerpo') || caja.firstElementChild;
    if (!cuerpo) return;

    // Si cabe de sobra, no se toca: un boton para 20 px de mas es ruido.
    if (cuerpo.scrollHeight <= limite * 1.25) return;

    caja.dataset.pfListo = 'si';
    caja.style.setProperty('--pf-alto-plegado', limite + 'px');
    caja.classList.add('pf-descripcion--plegable', 'pf-descripcion--plegada');

    if (!cuerpo.id) cuerpo.id = 'pf-descripcion-' + (++contador);

    var lang = idioma();
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'pf-descripcion__boton';
    boton.setAttribute('aria-expanded', 'false');
    boton.setAttribute('aria-controls', cuerpo.id);
    boton.textContent = TEXTOS.abrir[lang];

    boton.addEventListener('click', function () {
      var plegada = caja.classList.toggle('pf-descripcion--plegada');
      boton.setAttribute('aria-expanded', plegada ? 'false' : 'true');
      boton.textContent = plegada ? TEXTOS.abrir[lang] : TEXTOS.cerrar[lang];
      if (plegada) {
        // Al cerrar, volver arriba de la descripcion para no dejar al cliente perdido
        // a mitad de pagina.
        var suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        caja.scrollIntoView({ behavior: suave, block: 'nearest' });
        boton.focus();
      }
    });

    caja.insertAdjacentElement('afterend', boton);
  }

  function iniciar() {
    document.querySelectorAll('[data-pf-descripcion]').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas repinta las secciones.
  document.addEventListener('shopify:section:load', iniciar);
})();
